import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';

// function initSliderWorksHome() {
//     if ($('.works-home-swiper').length) {
//         new Swiper('.works-home-swiper', {
//             modules: [Navigation], spaceBetween: 20, slidesPerView: 1, navigation: {
//                 nextEl: '.works-home-swiper__next', prevEl: '.works-home-swiper__prev',
//             },
//         });
//     }
// }

function initSliderGeo() {
    if ($('.schedine-swiper').length) {
        new Swiper('.schedine-swiper', {
            modules: [Navigation],
            slidesPerView: 1.2,
            spaceBetween: 20,
            grabCursor: true,
            navigation: {
                nextEl: '.schedine-swiper__next',
                prevEl: '.schedine-swiper__prev',
            },
            breakpoints: {
                640: {slidesPerView: 2.2, spaceBetween: 24},
                1024: {slidesPerView: 3.2, spaceBetween: 28},
                1400: {slidesPerView: 4.2, spaceBetween: 32},
            },
        });
    }
}

function initFaceSlider() {
    if ($('.gallery-face').length) {
        new Swiper('.facetoface-swiper', {
            modules: [Navigation],
            slidesPerView: 1, spaceBetween: 16, grabCursor: true, navigation: {
                nextEl: '.gallery-face__next', prevEl: '.gallery-face__prev',
            }, breakpoints: {
                768: {slidesPerView: 3, spaceBetween: 20},
                1024: {slidesPerView: 5, spaceBetween: 20, allowTouchMove: false},
            },
        });
    }
}

export {
    // initSliderWorksHome,
    initSliderGeo,
    initFaceSlider
}
